import { render } from "./TopNavigationButton.vue?vue&type=template&id=6c0af108&ts=true"
import script from "./TopNavigationButton.vue?vue&type=script&lang=ts"
export * from "./TopNavigationButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__